// Capabilities that are available in native app
enum NativeCapability {
  SebsTile = 'SebsTile'
}

export default NativeCapability;
